// src/components/About.js
import React from "react";
import SectionTitle from "./shared/SectionTitle";
import resumeData from "../data/resumeData";

const About = () => {
	const { personalInfo } = resumeData;

	return (
		<section className="max-w-6xl mx-auto">
			<SectionTitle>About Me</SectionTitle>
			<div className="bg-white border border-slate-200/80 shadow-card rounded-2xl overflow-hidden mb-12">
				<div className="flex flex-col md:flex-row">
					<div className="md:w-2/3 p-8 md:p-10">
						<p className="mb-6 text-lg leading-relaxed text-slate-600">
							I'm a Computer Engineering student at Virginia Tech
							with an interest in robotics, embedded systems, and
							software development. Through my experiences at
							Nokia Bell Labs and Moog, Inc., I've developed
							strong skills in systems programming, Linux
							programming, networking, and hardware integration.
						</p>
						<p className="mb-6 text-lg leading-relaxed text-slate-600">
							My technical knowledge spans from low-level firmware
							development for custom hardware to building and
							managing enterprise-grade server infrastructure. I
							enjoy solving complex problems that bridge the gap
							between hardware and software.
						</p>
						<p className="text-lg leading-relaxed text-slate-600">
							Outside of my academic pursuits, I'm actively
							involved in{" "}
							<a
								target="_blank"
								href="https://www.vtbolt.com"
								className="text-brand-600 font-medium hover:text-brand-700 underline decoration-brand-300 underline-offset-2"
								rel="noreferrer"
							>
								Virginia Tech's BOLT team
							</a>
							, where I contribute to the development of a fully
							custom-build electric superbike. We run at 600V and
							have reached a top speed of 160mph. Personally, I
							have worked on the rider interface, code for our
							custom BMS, and a custom GUI for the BMS, connected
							over USB-CDC.
						</p>
					</div>
					<div className="md:w-1/3 bg-slate-50 border-t md:border-t-0 md:border-l border-slate-200/70 p-8 md:p-10 flex flex-col justify-center space-y-6">
						<div>
							<h3 className="text-xs font-semibold uppercase tracking-[0.14em] text-brand-600 mb-3">
								Education
							</h3>
							<p className="font-semibold text-lg text-slate-900">
								{personalInfo.education.school}
							</p>
							<p className="text-slate-600">
								{personalInfo.education.degree}
							</p>
							<p className="text-slate-600">
								{personalInfo.education.gpa}
							</p>
							<p className="text-slate-500">
								{personalInfo.education.graduation}
							</p>
						</div>
						<div>
							<h3 className="text-xs font-semibold uppercase tracking-[0.14em] text-brand-600 mb-3">
								Location
							</h3>
							<p className="text-slate-600">
								{personalInfo.education.location}
							</p>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
};

export default About;
